import { useEffect, useState } from 'react'
import { Loader2, RefreshCw, Search } from 'lucide-react'
import api from '../../utils/api'

export default function UserReminderShowLogsTab() {
  const [loading, setLoading] = useState(false)
  const [searchInput, setSearchInput] = useState('')
  const [phone, setPhone] = useState('')
  const [statusInput, setStatusInput] = useState('')
  const [confirmStatus, setConfirmStatus] = useState('')
  const [routeKey, setRouteKey] = useState('')
  const [stageInput, setStageInput] = useState('')
  const [stageNo, setStageNo] = useState('')
  const [records, setRecords] = useState([])
  const [pagination, setPagination] = useState({ page: 1, limit: 20, total: 0, totalPages: 1 })
  const [jumpPage, setJumpPage] = useState('')

  const fetchData = async (page = 1, targetPhone = phone, targetStatus = confirmStatus, targetRouteKey = routeKey, targetStageNo = stageNo) => {
    const trimmedPhone = String(targetPhone || '').trim()
    const trimmedStatus = String(targetStatus || '').trim()
    const trimmedRouteKey = String(targetRouteKey || '').trim()
    const trimmedStageNo = String(targetStageNo || '').trim()
    setLoading(true)
    setPhone(trimmedPhone)
    setConfirmStatus(trimmedStatus)
    setRouteKey(trimmedRouteKey)
    setStageNo(trimmedStageNo)

    try {
      const response = await api.get('/admin/user-reminder-show-logs', {
        params: {
          phone: trimmedPhone,
          confirmStatus: trimmedStatus,
          routeKey: trimmedRouteKey || undefined,
          stageNo: trimmedStageNo || undefined,
          page,
          limit: pagination.limit
        }
      })

      if (response.data.success) {
        const data = response.data.data || response.data || {}
        const pager = data.pagination || {}

        setRecords(data.list || [])
        setPagination((prev) => ({
          page: pager.page || 1,
          limit: pager.limit || prev.limit,
          total: pager.total || 0,
          totalPages: pager.totalPages || 1
        }))
      }
    } catch (error) {
      console.error('获取用户弹窗情况失败:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData(1, '', '', '', '')
  }, [])

  const handleSearch = (e) => {
    e.preventDefault()
    fetchData(1, searchInput, statusInput, routeKey, stageInput)
  }

  const handleReset = () => {
    setSearchInput('')
    setStatusInput('')
    setRouteKey('')
    setStageInput('')
    setJumpPage('')
    fetchData(1, '', '', '', '')
  }

  const handleJump = () => {
    const page = Number(jumpPage)
    if (!jumpPage.trim() || isNaN(page)) {
      setJumpPage('')
      return
    }
    if (page < 1 || page > pagination.totalPages) {
      alert(`请输入 1 ~ ${pagination.totalPages} 之间的页码`)
      return
    }
    fetchData(page, phone, confirmStatus, routeKey, stageNo)
    setJumpPage('')
  }

  const getStatusClassName = (status) => {
    if (status === 'confirmed') {
      return 'text-green-600'
    }
    if (status === 'unconfirmed') {
      return 'text-red-600'
    }
    return 'text-gray-900'
  }

  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <h2 className="text-xl font-bold text-gray-900 dark:text-white">用户弹窗情况</h2>

        <form onSubmit={handleSearch} className="flex flex-wrap items-center gap-2">
          <div className="relative min-w-[220px]">
            <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              placeholder="手机号模糊搜索"
              className="w-full rounded-lg border border-gray-300 bg-white py-2 pl-9 pr-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-gray-700 dark:bg-gray-800 dark:text-white"
            />
          </div>
          <select
            value={statusInput}
            onChange={(e) => setStatusInput(e.target.value)}
            className="rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-gray-700 dark:bg-gray-800 dark:text-white"
          >
            <option value="">全部状态</option>
            <option value="confirmed">已确认</option>
            <option value="unconfirmed">未确认</option>
          </select>
          <select
            value={routeKey}
            onChange={(e) => setRouteKey(e.target.value)}
            className="rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-gray-700 dark:bg-gray-800 dark:text-white"
          >
            <option value="">全部路线</option>
            <option value="unactivated">未激活用户</option>
            <option value="activated_low_cost_15d">低消耗用户</option>
            <option value="low_balance_unpaid">低余额用户</option>
          </select>
          <select
            value={stageInput}
            onChange={(e) => setStageInput(e.target.value)}
            className="rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-gray-700 dark:bg-gray-800 dark:text-white"
          >
            <option value="">全部次数</option>
            <option value="1">第1次</option>
            <option value="2">第2次</option>
            <option value="3">第3次</option>
          </select>
          <button type="submit" className="rounded-lg bg-blue-600 px-4 py-2 text-sm text-white hover:bg-blue-700">
            查询
          </button>
          <button type="button" onClick={handleReset} className="rounded-lg bg-gray-100 px-4 py-2 text-sm text-gray-700 hover:bg-gray-200">
            重置
          </button>
          <button
            type="button"
            onClick={() => fetchData(pagination.page, phone, confirmStatus, routeKey, stageNo)}
            className="inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-4 py-2 text-sm hover:bg-gray-50"
          >
            <RefreshCw className="h-4 w-4" />
            刷新
          </button>
        </form>
      </div>

      {loading ? (
        <div className="flex items-center justify-center rounded-xl border border-gray-200 bg-white py-12">
          <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
        </div>
      ) : (
        <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
          <div className="border-b border-gray-200 bg-white px-6 py-4 text-sm text-gray-500">
            当前筛选手机号：{phone || '全部'}，确认状态：{confirmStatus === 'confirmed' ? '已确认' : confirmStatus === 'unconfirmed' ? '未确认' : '全部'}
          </div>
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">弹窗时间</th>
                  <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">确认状态</th>
                  <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">确认时间</th>
                  <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">最新使用时间</th>
                  <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">用户UID</th>
                  <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">手机号</th>
                  <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">路线/页面</th>
                  <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">弹窗触发原因</th>
                  <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">mode类型</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white">
                {records.length > 0 ? (
                  records.map((item) => (
                    <tr key={item.id} className="hover:bg-gray-50">
                      <td className="px-6 py-4 text-sm text-gray-900">{item.reminder_shown_at || '-'}</td>
                      <td className={`px-6 py-4 text-sm font-medium ${getStatusClassName(item.confirm_status)}`}>
                        {item.confirm_status_label || '-'}
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-900">{item.display_confirmed_at || '-'}</td>
                      <td className="px-6 py-4 text-sm text-gray-900">{item.latest_usage_at || '-'}</td>
                      <td className="px-6 py-4 text-sm text-gray-900">{item.user_id || '-'}</td>
                      <td className="px-6 py-4 text-sm text-gray-900">{item.phone || '-'}</td>
                      <td className="px-6 py-4 text-sm text-gray-900">{item.route_label ? `${item.route_label} / ${item.page_key || '-'} / 第${item.stage_no || '-'}次` : '-'}</td>
                      <td className="px-6 py-4 text-sm text-gray-900">{item.trigger_reason || '-'}</td>
                      <td className="px-6 py-4 text-sm text-gray-900">{item.scope_mode || '-'}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={9} className="px-6 py-10 text-center text-sm text-gray-500">
                      暂无弹窗记录
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="flex items-center justify-between bg-gray-50 px-6 py-4">
            <div className="text-sm text-gray-600">
              共 {pagination.total} 条，第 {pagination.page}/{pagination.totalPages} 页
            </div>
            <div className="flex items-center gap-2">
              <input
                type="number"
                value={jumpPage}
                onChange={(e) => setJumpPage(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleJump()}
                placeholder="页码"
                min={1}
                max={pagination.totalPages}
                className="w-16 rounded-lg border border-gray-300 px-2 py-1 text-sm text-center focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white"
              />
              <button
                onClick={handleJump}
                className="rounded-lg border border-gray-300 px-3 py-1 text-sm hover:bg-gray-100 dark:border-gray-600 dark:hover:bg-gray-700"
              >
                跳转
              </button>
              <button
                disabled={pagination.page <= 1}
                onClick={() => fetchData(pagination.page - 1, phone, confirmStatus, routeKey, stageNo)}
                className="rounded-lg border border-gray-300 px-3 py-1 disabled:opacity-50"
              >
                上一页
              </button>
              <button
                disabled={pagination.page >= pagination.totalPages}
                onClick={() => fetchData(pagination.page + 1, phone, confirmStatus, routeKey, stageNo)}
                className="rounded-lg border border-gray-300 px-3 py-1 disabled:opacity-50"
              >
                下一页
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
